var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import { withTheme } from "styled-components";
import authentication from "@irati/auth";
import id from "@irati/utils/id";
import PerksGOHighlight from "@irati-web/perksgo/src/components/PerksGOHighlight";
import isPerksGO from "@irati/deals/helpers/deals/isPerksGO";
import { COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS } from "@irati/deals/constants/dealType";
import getCurrency from "@irati/deals/helpers/deals/currency";
import { isUserDOBRequired } from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth";
import isBoostedPerk from "@irati/deals/helpers/deals/isBoostedPerk";
import { getTimeLimitedType } from "@irati/deals/helpers/deals/isTimeLimited";
import Flex from "@irati/ui/src/Flex";
import { H1 } from "@irati/ui/src/Typography";
import BoostedSaving from "../BoostedSaving";
import { H4Title, H5Title, StyledSaving } from "./styled";
import DealHighlight, { DealHighlightRow } from "../DealHighlight";
import DealModes from "../../enums/DealModes";
var DealHeaderDetails = /** @class */ (function (_super) {
    __extends(DealHeaderDetails, _super);
    function DealHeaderDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DealHeaderDetails.prototype.render = function () {
        var _a, _b;
        var _c = this.props, deal = _c.deal, mode = _c.mode, theme = _c.theme;
        var isCompanyBenefit = deal.type === DEAL_TYPE_COMPANY_BENEFITS;
        var savingsType = get(deal, "savings.userSavings.type", null);
        var savingsValue = get(deal, "savings.userSavings.value", null);
        var savingsHeader = isCompanyBenefit ? "Save" : deal.savings.userSavings && get(deal, "savings.userSavings.header", null);
        var deliveryHighlight = deal.deliveryHighlight;
        var typeHighlight = getTimeLimitedType(deal);
        var isFullPage = mode === DealModes.FullPage;
        var isCompact = mode === DealModes.Compact;
        var dealRequiresUserDOB = isUserDOBRequired(deal);
        var idNamespace = id("deal-header-details", this.props);
        return (React.createElement("div", { id: idNamespace },
            isFullPage && (React.createElement(H1, { id: id("h2-title", idNamespace), paddingBottom: 2, overflowWrap: "break-word" }, deal.header)),
            !isFullPage && !isCompact && (React.createElement(H4Title, { id: id("h4-title", idNamespace), paddingBottom: 1.5, overflowWrap: "break-word" }, deal.header)),
            !isFullPage && isCompact && (React.createElement(H5Title, { id: id("h5-title", idNamespace), paddingBottom: 1.5, overflowWrap: "break-word" }, deal.header)),
            React.createElement(Flex, { justifyContent: isCompact ? "center" : "space-between", minHeight: theme.spacing.eight },
                !isCompact && (React.createElement(DealHighlight, null,
                    React.createElement(DealHighlightRow, { id: id("type", idNamespace), type: typeHighlight, size: 20 }),
                    React.createElement(DealHighlightRow, { id: id("delivery", idNamespace), type: deliveryHighlight, size: 20 }),
                    authentication.apps("perks.perksGo") && isPerksGO(deal) && React.createElement(PerksGOHighlight, { id: id("perksgo-highlight", idNamespace) }))),
                isBoostedPerk(deal) && (React.createElement(BoostedSaving, { isFullPage: isFullPage, userSavings: (_a = deal === null || deal === void 0 ? void 0 : deal.savings) === null || _a === void 0 ? void 0 : _a.userSavings, boostedSavings: (_b = deal === null || deal === void 0 ? void 0 : deal.savings) === null || _b === void 0 ? void 0 : _b.boostedSavings })),
                !isBoostedPerk(deal) && (React.createElement(StyledSaving, { id: idNamespace, "data-test": "savings-value", compactMode: isCompact, fullPageMode: isFullPage, header: savingsHeader, saving: savingsValue, type: savingsType, addSavingsTypeEmoji: dealRequiresUserDOB, currency: getCurrency(deal), smallSavingsHeader: true })))));
    };
    DealHeaderDetails.defaultProps = {
        mode: DealModes.Default
    };
    return DealHeaderDetails;
}(PureComponent));
export default withTheme(DealHeaderDetails);
